import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsAgendaDealers = (idAgenda, idArea) => apiActionCreator({
  'endpoint': `/wts/agenda/cursoAgendaDealer?id_agenda=${idAgenda}&id_area=${idArea}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_AGENDA_DEALERS,
    ActionTypes.FETCHED_WTS_AGENDA_DEALERS,
    [
      ActionTypes.FETCHED_WTS_AGENDA_DEALERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsAgendaDealerLastId = () => apiActionCreator({
  'endpoint': '/wts/agenda/cursoAgendaDealer?last_id=true',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_AGENDA_DEALER_LAST_ID,
    ActionTypes.FETCHED_WTS_AGENDA_DEALER_LAST_ID,
    [
      ActionTypes.FETCHED_WTS_AGENDA_DEALER_LAST_ID_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createWtsAgendaDealer = (idAgenda, idArea, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/agenda/cursoAgendaDealer',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_AGENDA_DEALER,
        [
          () => {
            dispatch(getWtsAgendaDealers(idAgenda, idArea));
            return {'type': ActionTypes.CREATED_WTS_AGENDA_DEALER};
          },
          MessageActions.addMessageBoxInfo('Concesionario asignado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_AGENDA_DEALER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsAgendaDealer = (idAgenda, idArea, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/agenda/cursoAgendaDealer',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_AGENDA_DEALER,
        [
          () => {
            dispatch(getWtsAgendaDealers(idAgenda, idArea));
            return {'type': ActionTypes.UPDATED_WTS_AGENDA_DEALER};
          },
          MessageActions.addMessageBoxInfo('Registro actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_AGENDA_DEALER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const deleteWtsAgendaDealer = (idAgenda, idArea, ruc) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/agenda/cursoAgendaDealer?id_agenda=${idAgenda}&ruc=${ruc}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_WTS_AGENDA_DEALER,
        [
          () => {
            dispatch(getWtsAgendaDealers(idAgenda, idArea));
            return {'type': ActionTypes.DELETED_WTS_AGENDA_DEALER};
          },
          MessageActions.addMessageBoxInfo('Asignación eliminada satisfactoriamente'),
        ],
        [
          ActionTypes.DELETED_WTS_AGENDA_DEALER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};
